import { NavItemSchema } from '@shared/interfaces/nav/nav-item-schema';

export const connectionpointNavItems: NavItemSchema[] = [
  {
    title: 'connectionpoint.navItems.overview',
    routeTemplate: ['/connectionpoint', '{id}']
  },
  {
    title: 'connectionpoint.navItems.meterframe',
    routeTemplate: ['/connectionpoint', '{id}', 'meterframe']
  },
  {
    title: 'connectionpoint.navItems.meteringpoints',
    routeTemplate: ['/connectionpoint', '{id}', 'meteringpoints']
  },
  {
    title: 'connectionpoint.navItems.history',
    routeTemplate: ['/connectionpoint', '{id}', 'history']
  }
];
